
<div  style="display: block;width: '90% !important'; height: '100% !important'">
  <canvas  baseChart 
[data]="chartData" 
[type]="'bar'"
[options]="barChartOptions"
></canvas>
</div>
<br>
@if(selectedRow.customerId !== 'null'){
<div>
  <label for="customerID" class="text-center text-color-grey mg-l-18">
       Customer Id - {{selectedRow.customerId}}
</label>
</div>
}
@if(selectedRow.customerId !== 'null'){
<div>
    <label for="customerName" class="text-center text-color-grey mg-l-18">
        Customer Name - {{selectedRow.customerName !== 'null' ? selectedRow.customerName : ''}}
  </label>
  </div>
}